import { IConfigData } from '@df/catalog/config/config.interfaces';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { ICmsConfig } from '@icms/core/resource/config/icms-config';
export const CMS_CONFIG_POS = 'pos';

export interface IICmsConfigPosDataContent extends IConfigData {
    posFormId?: string;
}
export interface IICmsConfigPosData extends ICmsConfig<IICmsConfigPosDataContent> {}
ICmsContentService.registerConfig({
    id: CMS_CONFIG_POS,
    name: 'POS configuration',
    fields: [
        {
            key: 'posFormId',
            type: NICmsContentField.EFieldType.text,
            title: 'POS form id'
        }
    ]
});
